import { render, staticRenderFns } from "./LoyaltyExample.vue?vue&type=template&id=2292a9b8&scoped=true&"
import script from "./LoyaltyExample.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyExample.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyExample.vue?vue&type=style&index=0&id=2292a9b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2292a9b8",
  null
  
)

export default component.exports